/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2025 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';

export class clinicaldaysheetstat extends IceEntity {
  day: any = NaN;
  appointment_count: number = 0;
  payer_count: number = 0;
  eligibility_check_count: number = 0;
  encounter_count: number = 0;
  encounter_complete_count: number = 0;
  encounter_signed_count: number = 0;
  revenue_total: number = 0.0;
  collected_total: number = 0.0;
  patient_consent_count: number = 0;
  service_count: number = 0;
  diagnosis_count: number = 0;
  claim_ready_count: number = 0;
  claim_clean_count: number = 0;
  claim_sent_count: number = 0;

  public gettablename(): string {
    return "CLINICAL_DAYSHEET_STAT";
  }
}
